import { UNKNOWN_ERROR_SCOPE } from './const';
import { ServerError } from './ServerError';

/**
 * Handles ServerErrors on the client side
 */
export const PojoToServerError = (data: any) => {
  const isServerError = 'name' in data && data.name === 'ServerError'
    && 'message' in data && typeof data.message === 'string'
    && 'status' in data && typeof data.status === 'number';

  if (isServerError) {
    return new ServerError({
      message: data.message,
      scope: data.scope || UNKNOWN_ERROR_SCOPE,
      shouldSkipLogs: false,
      status: data.status ?? 500,
    });
  }

  return null;
};
